const handleSearch = () => {
	const $searchContainer = $('.search-component');
	const $pagesResultsPagination = $searchContainer.find('#pages .pagination-nav-btn');
	const $tabLinks = $searchContainer.find('button.nav-link');
	const $searchInputForm = $searchContainer.find('.js-search form');

	$pagesResultsPagination.on('click', (event) => {
		const url = new URL(window.location);
		url.searchParams.set('page', event.currentTarget.dataset.nextpage);
		window.location = url.href;
	});

	$tabLinks.on('click', (event) => {
		const url = new URL(window.location);
		url.searchParams.set('activetab', event.currentTarget.dataset.target);
		window.history.pushState({}, null, url.href);
	});

	$searchInputForm.on('submit', (event) => {
		event.preventDefault();
		const query = event.target.elements['q'].value;
		
		if(query.length){
			const url = new URL(window.location);
			url.searchParams.delete('filter')
			url.searchParams.set('q', event.target.elements['q']?.value ?? '');
			url.searchParams.set('page', 1);
			window.location = url;
		}
	});

	$(function(){
		const url = new URL(window.location);

		//Set search input value
		$searchInputForm.find('input[name="q"]').val(url.searchParams.get('q') ?? '');

		//Activate current tab
		const activeTab = url.searchParams.get('activetab') 
							? $tabLinks.filter((i, ele) => ele.dataset.target == url.searchParams.get('activetab')) : $tabLinks[0];
		$(activeTab).tab('show');
	});
	
};

handleSearch();
